module.exports = __webpack_public_path__ + "img/folder-shared.db599ac8.svg";